import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import _ from "lodash";

import { Translate, I18n } from "react-redux-i18n";
import moment from "moment";

import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

import { setAlert } from "../../../actions/alertActions";

import ArrowCardToggle from "../../utils/components/ArrowCardToggle";
import GroupCard from "../../utils/components/GroupCard";
import UserCard from "../../utils/components/UserCard";

import "../../../styles/components/evs/modals/SpecsEV.scss";

class SpecsEV extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.state = {
      kms: 0,
      dateKms: "",
    };
    this.findHighestKms = this.findHighestKms.bind(this);
    this.modalTitleConvertion = this.modalTitleConvertion.bind(this);
    this.modalBrandConvertion = this.modalBrandConvertion.bind(this);
  }

  componentDidMount() {
    this._mounted = true;

    this.findHighestKms();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  findHighestKms() {
    const listOfKMs = this.props.selectedEV?.listOfKMs;

    if (listOfKMs !== undefined) {
      if (listOfKMs.length > 0) {
        const highestNumberOfKm = listOfKMs.reduce((prev, current) => {
          return prev.kms > current.kms ? prev : current;
        });

        this.setState({
          kms: highestNumberOfKm.kms,
          dateKms: highestNumberOfKm.chargingDate,
        });
      }
    }
  }

  handleDeleteUser(e, user) {
    const patch = {
      evId: this.props.selectedEV.evId,
      listOfGroupDrivers: [],
      listOfDrivers: [user._id],
    };

    axios
      .patch("/api/private/evs/removeDrivers", patch)
      .then((res) => {
        if (res.status === 200) {
          this.props.fetchFleets();
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleDeleteGroup(e, group) {
    const patch = {
      evId: this.props.selectedEV.evId,
      listOfGroupDrivers: [group.groupId],
      listOfDrivers: [],
    };

    axios
      .patch("/api/private/evs/removeDrivers", patch)
      .then((res) => {
        if (res.status === 200) {
          this.props.fetchFleets();
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  modalTitleConvertion() {
    if (this.props.selectedEV.brand && this.props.selectedEV.model) {
      if (this.props.selectedEV.brand === "TYPEUSER") {
        return (
          I18n.t("general_contractTypeUser") + " " + this.props.selectedEV.model
        );
      }
      if (this.props.selectedEV.brand === "TYPECARD") {
        return I18n.t("myEvs_card") + " " + this.props.selectedEV.model;
      } else {
        return this.props.selectedEV.brand + " " + this.props.selectedEV.model;
      }
    } else {
      return "-";
    }
  }

  modalBrandConvertion() {
    if (this.props.selectedEV.brand && this.props.selectedEV.model) {
      if (this.props.selectedEV.brand === "TYPEUSER") {
        return I18n.t("general_contractTypeUser");
      }
      if (this.props.selectedEV.brand === "TYPECARD") {
        return I18n.t("myEvs_card");
      } else {
        return this.props.selectedEV.brand;
      }
    } else {
      return "-";
    }
  }

  render() {
    return (
      this.props.selectedEV && (
        <Modal
          id="specsEV"
          show={this.props.show}
          onHide={this.props.onHide}
          centered
        >
          <Modal.Header>
            <Modal.Title>{this.modalTitleConvertion()}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.props.selectedEV.imageContent && (
              <div className="image-container">
                <img
                  src={this.props.selectedEV.imageContent}
                  alt={this.props.selectedEV.brand + " Image"}
                />
              </div>
            )}

            <div className="specs-container">
              <div className="item">
                <div className="title">
                  <Translate value="backOffice_evSpecs_join_brand" />
                </div>
                <div className="text">{this.modalBrandConvertion()}</div>
              </div>

              <div className="item">
                <div className="title">
                  <Translate value="backOffice_evSpecs_join_model" />
                </div>
                <div className="text">
                  {this.props.selectedEV.model
                    ? this.props.selectedEV.model
                    : "-"}
                </div>
              </div>

              <div className="break" />

              <div className="item">
                <div className="title">
                  <Translate value="backOffice_evSpecs_join_country" />
                </div>
                <div className="text">
                  {this.props.selectedEV.country
                    ? this.props.selectedEV.country
                    : "-"}
                </div>
              </div>

              <div className="item">
                <div className="title">
                  <Translate value="evs_range" />
                </div>
                <div className="text">
                  {this.props.selectedEV.evInfo.range
                    ? this.props.selectedEV.evInfo.range
                    : "-"}
                  km
                </div>
              </div>

              <div className="break" />

              <div className="item">
                <div className="title">
                  <Translate value="evs_batteryCapacity" />
                </div>
                <div className="text">
                  {this.props.selectedEV.evInfo.maxBatteryCapacity
                    ? this.props.selectedEV.evInfo.maxBatteryCapacity
                    : "-"}
                  kWh
                </div>
              </div>

              <div className="item">
                <div className="title">
                  <Translate value="evs_internalChargePower" />
                </div>
                <div className="text">
                  {this.props.selectedEV.evInfo.internalChargerPower
                    ? this.props.selectedEV.evInfo.internalChargerPower
                    : "-"}
                  kW
                </div>
              </div>

              <div className="break" />

              <div className="item">
                <div className="title">
                  <Translate value="evs_fastChargePower" />
                </div>
                <div className="text">
                  {this.props.selectedEV.evInfo.maxFastChargingPower
                    ? this.props.selectedEV.evInfo.maxFastChargingPower
                    : "-"}
                  kW
                </div>
              </div>

              <div className="item">
                <div className="title">
                  <Translate value="evs_licensePlate" />
                </div>
                <div className="text">
                  {this.props.selectedEV.licensePlate
                    ? String(this.props.selectedEV.licensePlate).toUpperCase()
                    : "-"}
                </div>
              </div>

              <div className="break" />

              <div className="item">
                <div className="title">
                  <Translate value="myEvs_additionalInfo" />
                </div>
                <div className="text">
                  {this.props.selectedEV.otherInfo
                    ? String(this.props.selectedEV.otherInfo)
                    : "-"}
                </div>
              </div>
              {this.props.userPackage?.mileageEntryEnabled &&
                (this.props.selectedEV?.acceptKMs ||
                  (!this.props.selectedEV?.acceptKMs &&
                    this.state.kms !== 0)) && (
                  <div className="item">
                    <div className="title">
                      <Translate value="evs_kms" />{" "}
                      {this.state.kms === 0
                        ? moment().format("DD-MM-YYYY")
                        : moment(this.state.dateKms).format("DD-MM-YYYY")}
                    </div>
                    <div className="text">
                      {this.state.kms !== null
                        ? Math.round(this.state.kms) + "km"
                        : "-"}
                    </div>
                  </div>
                )}
            </div>

            {this.props.selectedEV.listOfDrivers &&
              this.props.selectedEV.listOfDrivers.length > 0 && (
                <Accordion className="drivers-accordion">
                  <ArrowCardToggle eventKey="0">
                    <div className="driver-title">
                      <Translate value="backOffice_evSpecs_join_drivers" />
                    </div>
                  </ArrowCardToggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body className="drivers-container">
                      {this.props.selectedEV.listOfDrivers.map((u) => {
                        return (
                          <UserCard
                            key={u._id}
                            type="info"
                            name={u.name || ""}
                            avatar={u.imageContent}
                            info={
                              <>
                                {`${u.internationalPrefix || ""} ${
                                  u.mobile || ""
                                }`}
                                <br />
                                <Translate
                                  value={`evs_paymentBy${_.capitalize(
                                    u.paymenteBy
                                  )}`}
                                />
                                <br />
                                <Translate
                                  value={`evs_billingBy${_.capitalize(
                                    u.billingBy
                                  )}`}
                                />
                              </>
                            }
                            evSpecs={true}
                            onDelete={(e) => this.handleDeleteUser(e, u)}
                          />
                        );
                      })}
                    </Card.Body>
                  </Accordion.Collapse>
                </Accordion>
              )}

            {this.props.selectedEV.listOfGroupDrivers &&
              this.props.selectedEV.listOfGroupDrivers.length > 0 && (
                <Accordion className="groups-accordion">
                  <ArrowCardToggle eventKey="0">
                    <div className="group-title">
                      <Translate value="backOffice_evSpecs_join_groups" />
                    </div>
                  </ArrowCardToggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body className="drivers-container">
                      {this.props.selectedEV.listOfGroupDrivers.map((u) => {
                        return (
                          <GroupCard
                            key={u._id}
                            type="info"
                            avatar={u.imageContent}
                            name={u.name || ""}
                            info={
                              <>
                                {`${u.internationalPrefix || ""} ${
                                  u.mobile || ""
                                }`}
                                <br />
                                <Translate
                                  value={`evs_paymentBy${_.capitalize(
                                    u.paymenteBy
                                  )}`}
                                />
                                <br />
                                <Translate
                                  value={`evs_billingBy${_.capitalize(
                                    u.billingBy
                                  )}`}
                                />
                              </>
                            }
                            evSpecs={true}
                            onDelete={(e) => this.handleDeleteGroup(e, u)}
                          />
                        );
                      })}
                    </Card.Body>
                  </Accordion.Collapse>
                </Accordion>
              )}

            <div className="add-drivers-container">
              <button
                type="button"
                onClick={() => {
                  this.props.assignDrivers();
                }}
              >
                <Translate value="evs_assignDrivers" />
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  country: state.account.accountData.country,
  userPackage: state.account.accountData.userPackage,
  brand: state.app.brand,
});

export default connect(mapStateToProps, { setAlert })(SpecsEV);
